import _defaults from 'lodash/defaults';
import qs from 'query-string';

export const serialize = (
  params: Record<string, any>, defaultParams: Record<string, number|string|boolean> = {}) => (
  qs.stringify(_defaults(params, defaultParams), {
    skipEmptyString: true,
    skipNull: true,
  }));
